export const DEFAULT_BACKGROUND_URL = "https://firebasestorage.googleapis.com/v0/b/spellingame.appspot.com/o/public%2FBG%2Fbox.png?alt=media";

export const OTHERS = "";
